"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var FunctionUtil_1 = require("../utils/FunctionUtil");

var Cell = function Cell(_a) {
  var className = _a.className,
      text = _a.text,
      subText = _a.subText,
      _onClick = _a.onClick,
      _onMouseOver = _a.onMouseOver;
  return React.createElement("td", {
    onClick: function onClick() {
      return FunctionUtil_1.ifExistCall(_onClick, text);
    },
    onMouseOver: function onMouseOver() {
      return FunctionUtil_1.ifExistCall(_onMouseOver, text);
    },
    className: className
  }, React.createElement("div", null, text), subText && React.createElement("span", {
    className: "sub__text"
  }, subText));
};

exports.default = Cell;